var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"title":_vm.$t('eip.nav.translate')}},[_c('el-switch',{attrs:{"size":"mini"},on:{"input":_vm.changeTranslate},model:{value:(_vm.isTranslate),callback:function ($$v) {_vm.isTranslate=$$v},expression:"isTranslate"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }